import React from 'react';

// ─── ProStack NG brand mark (exact SVG from brand file) ─────
export function StackLogo({ size = 32, variant = 'color', className = '' }) {
  const w = Math.round(size * 1.18);
  const h = size;
  const top   = variant === 'white' ? '#ffffff'   : '#2563EB';
  const mid   = variant === 'white' ? '#ffffffBB' : '#1D4ED8';
  const bot   = variant === 'white' ? '#ffffff66' : '#1E3A8A';
  const shine = variant === 'white' ? '#ffffffCC' : '#93C5FD';

  return (
    <svg width={w} height={h} viewBox="0 0 52 44" fill="none" className={className} aria-label="ProStack NG">
      <path d="M6 30 L36 30 L46 38 L16 38 Z" fill={bot} opacity={variant === 'color' ? 0.5 : 0.4} />
      <path d="M2 20 L32 20 L42 28 L12 28 Z" fill={mid} opacity={variant === 'color' ? 0.75 : 0.65} />
      <path d="M0 10 L30 10 L40 18 L10 18 Z" fill={top} />
      <path d="M0 10 L30 10" stroke={shine} strokeWidth="1.5" opacity={variant === 'color' ? 0.7 : 0.5} />
    </svg>
  );
}

// ─── ProTrackNG app logo mark ────────────────────────────────
// A radar/pulse mark — represents tracking + intelligence
export function ProTrackMark({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-label="ProTrackNG">
      {/* Outer ring */}
      <circle cx="20" cy="20" r="18" stroke="#00d4a1" strokeWidth="1.5" opacity="0.3" />
      {/* Mid ring */}
      <circle cx="20" cy="20" r="12" stroke="#00d4a1" strokeWidth="1.5" opacity="0.5" />
      {/* Inner ring */}
      <circle cx="20" cy="20" r="6" stroke="#00d4a1" strokeWidth="1.5" opacity="0.8" />
      {/* Center dot */}
      <circle cx="20" cy="20" r="2.5" fill="#00d4a1" />
      {/* Pulse line — sweep indicator */}
      <line x1="20" y1="20" x2="34" y2="8" stroke="#00d4a1" strokeWidth="1.5" strokeLinecap="round" opacity="0.9" />
    </svg>
  );
}

// ─── Full ProTrackNG wordmark (logo + text) ──────────────────
// Use this in Sidebar and nav headers
export function ProTrackWordmark({ size = 32, textColor = '#ffffff', showPoweredBy = false }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <ProTrackMark size={size} />
        <div>
          <div style={{
            fontSize: size * 0.56,
            fontWeight: '800',
            color: textColor,
            letterSpacing: '-0.5px',
            lineHeight: 1,
            fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
          }}>
            ProTrack<span style={{ color: '#00d4a1' }}>NG</span>
          </div>
          {showPoweredBy && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '3px' }}>
              <span style={{ fontSize: '9px', color: 'rgba(255,255,255,0.3)', letterSpacing: '0.3px' }}>powered by</span>
              <StackLogo size={14} variant="white" />
              <span style={{ fontSize: '9px', color: 'rgba(255,255,255,0.4)', fontWeight: '600' }}>ProStack NG</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Compact icon-only mark for collapsed sidebar ────────────
export function ProTrackIcon({ size = 32 }) {
  return <ProTrackMark size={size} />;
}
